import SkapaSwitch, { type SwitchProps } from "@ingka/switch";

export const Switch = (props: SwitchProps) => {
  return <SkapaSwitch prefix="saleslead__" {...props} />;
};
